module.exports = __webpack_public_path__ + "static/media/Dayly_ios_6.47a404b3.jpg";